/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * `null` represents an indefinite duration.
 * @export
 * @interface PenaltyDuration
 */
export interface PenaltyDuration {
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    years?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    quarters?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    months?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    weeks?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    days?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    hours?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    minutes?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    seconds?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    milliseconds?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    year?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    quarter?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    month?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    week?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    day?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    hour?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    minute?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    second?: number;
    /**
     * 
     * @type {number}
     * @memberof PenaltyDuration
     */
    millisecond?: number;
}

/**
 * Check if a given object implements the PenaltyDuration interface.
 */
export function instanceOfPenaltyDuration(value: object): value is PenaltyDuration {
    return true;
}

export function PenaltyDurationFromJSON(json: any): PenaltyDuration {
    return PenaltyDurationFromJSONTyped(json, false);
}

export function PenaltyDurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PenaltyDuration {
    if (json == null) {
        return json;
    }
    return {
        
        'years': json['years'] == null ? undefined : json['years'],
        'quarters': json['quarters'] == null ? undefined : json['quarters'],
        'months': json['months'] == null ? undefined : json['months'],
        'weeks': json['weeks'] == null ? undefined : json['weeks'],
        'days': json['days'] == null ? undefined : json['days'],
        'hours': json['hours'] == null ? undefined : json['hours'],
        'minutes': json['minutes'] == null ? undefined : json['minutes'],
        'seconds': json['seconds'] == null ? undefined : json['seconds'],
        'milliseconds': json['milliseconds'] == null ? undefined : json['milliseconds'],
        'year': json['year'] == null ? undefined : json['year'],
        'quarter': json['quarter'] == null ? undefined : json['quarter'],
        'month': json['month'] == null ? undefined : json['month'],
        'week': json['week'] == null ? undefined : json['week'],
        'day': json['day'] == null ? undefined : json['day'],
        'hour': json['hour'] == null ? undefined : json['hour'],
        'minute': json['minute'] == null ? undefined : json['minute'],
        'second': json['second'] == null ? undefined : json['second'],
        'millisecond': json['millisecond'] == null ? undefined : json['millisecond'],
    };
}

export function PenaltyDurationToJSON(value?: PenaltyDuration | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'years': value['years'],
        'quarters': value['quarters'],
        'months': value['months'],
        'weeks': value['weeks'],
        'days': value['days'],
        'hours': value['hours'],
        'minutes': value['minutes'],
        'seconds': value['seconds'],
        'milliseconds': value['milliseconds'],
        'year': value['year'],
        'quarter': value['quarter'],
        'month': value['month'],
        'week': value['week'],
        'day': value['day'],
        'hour': value['hour'],
        'minute': value['minute'],
        'second': value['second'],
        'millisecond': value['millisecond'],
    };
}

